import { CreditCard, Home, MoreHorizontal, Settings, ShoppingCart, Store, Users, UsersRound, Bell, UserPlus, AlertTriangle } from "lucide-react";
import type { JSX } from "react";

export const iconMap: Record<string, JSX.Element> = {
  home: <Home size={22} />,
  users: <Users size={22} />,
  store: <Store size={22} />,
  more: <MoreHorizontal size={22} />,
  subscription: <CreditCard size={22} />,
  settings: <Settings size={22} />,
  items: <ShoppingCart size={22} />,
  customers: <UsersRound size={22} />,
  notification: <Bell size={22} />,
  newUser: <UserPlus />,
  newStore: <Store />,
  alert: <AlertTriangle />,
};